import React from "react";
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import { useStepFormApi } from "../hooks";

import "./index.css";
import { useSearchParams } from "react-router-dom";

type BasicStepFormPropsT = {
  stepFormApi: ReturnType<typeof useStepFormApi>;
  onFinish?: (data: Record<string, unknown>[]) => void;
  hideButtons?: boolean;
};

export function BasicStepForm({
  stepFormApi,
  onFinish,
  hideButtons,
}: BasicStepFormPropsT) {
  const {
    data,
    validity,
    touched,
    accessibility,
    steps,
    currentStepIndex,
    currentStepContent,
    previousStepEnabled,
    nextStepEnabled,
    finishEnabled,
    gotoPreviousStep,
    gotoNextStep,
    gotoStep,
  } = stepFormApi;
  const totalSteps = steps.length;
  const previousStepExists = currentStepIndex > 0;
  const nextStepExists = currentStepIndex < totalSteps - 1;

  const handleFinish = () => {
    if (onFinish) onFinish(data);
  };

  const [params] = useSearchParams();
  const DEV_MODE = !!params.get("DEV_MODE");

  const stepsModel = steps.map(({ name }, index) => ({
    label: name,
    disabled: !accessibility[index],
    icon: accessibility[index]
      ? validity[index]
        ? "pi pi-check-circle text-green-600"
        : touched[index]
        ? "pi pi-exclamation-circle text-red-600"
        : "pi pi-lock-open text-blue-600"
      : "pi pi-lock text-blue-600",
    className: "ago-BasicStepForm-step",
  }));

  return (
    <div>
      {DEV_MODE && (
        <div className="my-6">
          <Steps
            model={stepsModel}
            activeIndex={currentStepIndex}
            readOnly={DEV_MODE}
            onSelect={({ index }) => {
              if (DEV_MODE) {
                gotoStep(index);
              }
            }}
          />
        </div>
      )}
      {currentStepContent}
      {!hideButtons && (
        <div className="mt-4 flex">
          <div>
            {previousStepExists && (
              <Button
                label="Previous"
                className="p-button-secondary p-button-sm"
                disabled={!previousStepEnabled}
                onClick={gotoPreviousStep}
              />
            )}
          </div>

          <div className="text-right flex-grow-1">
            {nextStepExists && (
              <Button
                label="Next"
                className="p-button-sm"
                disabled={!nextStepEnabled}
                onClick={gotoNextStep}
              />
            )}
            {!nextStepExists && (
              <Button
                label="Finish"
                className="p-button-sm p-button-success"
                disabled={!finishEnabled}
                onClick={handleFinish}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
